<dgx-breadcrumbs [breadcrumbs]="breadcrumbs"></dgx-breadcrumbs
><dgx-downloadable-reports
  [initDaysPrior]="30"
  [maxDays]="93"
  [pathwayId]="pathway.id"
  location="Pathway Insights"
></dgx-downloadable-reports>
